import LoadingButton from '@mui/lab/LoadingButton';
import { styled } from '@mui/material/styles';

export const CommonButton = styled(LoadingButton)(() => ({
  height: '48px',
}));
